<template>
  <div class="empty-data-wrap">
    <div class="circle">
      <fps-img
        v-if="imgUrl"
        :src="imgUrl"
      />
    </div>
    <p
      v-for="(t, i) in texts"
      :key="i"
    >{{ t }}</p>
  </div>
</template>

<script>
export default {
  props: {
    imgUrl: {
      type: String,
      default: '',
    },
    texts: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data () {
    return {}
  },
}
</script>

<style lang="scss" scoped>
  .empty-data-wrap {
    background: var(--nc-bg-page, #fff);
    text-align: center;

    .circle {
      width: 300px;
      height: 180px;
      border-radius: 100%;
      margin: auto;
      margin-bottom: 40px;
    }

    p {
      width: 480px;
      margin: auto;
      font-size: 26px;
      line-height: 36px;
      font-weight: 500;
    }
  }
</style>
